module.exports = __webpack_public_path__ + "static/004-258f4c1a4f3ef58d483ee6f4b41700b8.png";